import React, { useState } from "react";
import { useAuth } from "../../AuthContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    outline: 0
};

const SetPasswordModal = ({ open, onClose, username }) => {
    const { handleSetPassword } = useAuth();
    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const getPasswordStrength = (password) => {
        if (!password) return { score: 0, label: "" };
        let score = 0;
        if (password.length >= 6) score++;
        if (/[A-Z]/.test(password)) score++;
        if (/[0-9]/.test(password)) score++;
        if (/[^A-Za-z0-9]/.test(password)) score++;
        let label = ["ضعیف", "متوسط", "قوی", "خیلی قوی"][Math.min(score - 1, 3)] || "";
        return { score, label };
    };

    const handleSubmit = async () => {
        setError("");
        if (newPassword.length < 6) return setError("رمز عبور باید حداقل ۶ کاراکتر باشد");
        if (newPassword !== repeatPassword) return setError("تکرار رمز عبور مطابقت ندارد");

        setLoading(true);
        try {
            await handleSetPassword(username, newPassword, repeatPassword);
            setSuccess("رمز عبور با موفقیت تغییر یافت!");
            setTimeout(() => onClose(), 1500);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <h5 className="mb-3">تعریف رمز عبور</h5>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <div className="mb-3">
                    <label className="mb-2">رمز عبور </label>
                    <div className="position-relative">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <span
                            onClick={() => setShowNewPassword((p) => !p)}
                            style={{ cursor: "pointer", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}
                        >
                            {showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </span>
                    </div>
                    {newPassword && (
                        <div className="mt-2">
                            <div
                                style={{
                                    height: "6px",
                                    borderRadius: "4px",
                                    backgroundColor: "#e0e0e0",
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        width: `${(getPasswordStrength(newPassword).score / 4) * 100}%`,
                                        height: "100%",
                                        borderRadius: "4px",
                                        transition: "width 0.3s",
                                        backgroundColor:
                                            getPasswordStrength(newPassword).score <= 1
                                                ? "#f44336"
                                                : getPasswordStrength(newPassword).score === 2
                                                    ? "#ff9800"
                                                    : getPasswordStrength(newPassword).score === 3
                                                        ? "#cddc39"
                                                        : "#4caf50",
                                    }}
                                />
                            </div>
                            <small className="d-block mt-1 fw-bold">
                                قدرت رمز: {getPasswordStrength(newPassword).label}
                            </small>
                        </div>
                    )}
                </div>

                <div className="mb-3">
                    <label className="mb-2">تکرار رمز عبور</label>
                    <div className="position-relative">
                        <input
                            type={showRepeatPassword ? "text" : "password"}
                            className="form-control"
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)}
                        />
                        <span
                            onClick={() => setShowRepeatPassword((p) => !p)}
                            style={{ cursor: "pointer", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}
                        >
                            {showRepeatPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </span>
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3">
                    <button className="btn btn-light" onClick={onClose}>
                        بعدا
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={20} /> : "ذخیره"}
                    </button>
                </div>
            </Box>
        </Modal>
    );
};

export default SetPasswordModal;